import {getErpAccessibleLocations} from 'utils/erpAccess';

export const getMrpLocationOptions = (rootState) => {
	return getErpAccessibleLocations(rootState);
};

export const getMrpActiveLocation = (rootState) => {
	const locations = getMrpLocationOptions(rootState);
	if (locations.length === 0) {
		return {
			locations,
			selectedLocation: null,
			location: null,
			location_binary_id: null,
			locationName: ''
		};
	}

	const selectedId = `${rootState?.locationSelected ?? rootState?.location ?? ''}`;
	const selectedLocation = locations.find((location) => `${location?.pkey}` === selectedId) || locations[0];
	return {
		locations,
		selectedLocation,
		location: selectedLocation?.pkey ?? null,
		location_binary_id: selectedLocation?.binary_id ?? null,
		locationName: selectedLocation?.name_display || selectedLocation?.name || ''
	};
};

export const getMrpLocationSignature = (rootState) => {
	const context = getMrpActiveLocation(rootState);
	return `${context.location ?? ''}:${context.location_binary_id ?? ''}`;
};

export const setMrpActiveLocation = (rootState, nextLocationId) => {
	const locations = getMrpLocationOptions(rootState);
	const selectedLocation = locations.find((location) => `${location?.pkey}` === `${nextLocationId}`) || locations[0] || null;
	if (!selectedLocation) {
		return null;
	}
	if (typeof rootState?.set === 'function') {
		rootState.set({
			locationSelected: selectedLocation.pkey,
			locationSelectedBinaryId: selectedLocation.binary_id
		});
	}
	return selectedLocation;
};

export const syncMrpActiveLocation = (rootState) => {
	const context = getMrpActiveLocation(rootState);
	if (
		context.location !== null
		&& typeof rootState?.set === 'function'
		&& (
			`${rootState?.locationSelected ?? ''}` !== `${context.location}`
			|| `${rootState?.locationSelectedBinaryId ?? ''}` !== `${context.location_binary_id ?? ''}`
		)
	) {
		rootState.set({
			locationSelected: context.location,
			locationSelectedBinaryId: context.location_binary_id
		});
	}
	return context;
};

export const applyMrpLocationToRequest = (model, rootState) => {
	const context = syncMrpActiveLocation(rootState);
	model.object = model.object || {};
	model.properties = model.properties || {};
	// ERP requests need these fields declared on the model at submit time because
	// the API helper only forwards read filters for properties marked queryable.
	model.properties.location = {
		...(model.properties.location || {}),
		settable: true,
		queryable: true
	};
	model.properties.location_binary_id = {
		...(model.properties.location_binary_id || {}),
		settable: true,
		queryable: true
	};
	if (context.location !== null) {
		model.object.location = context.location;
		model.object.location_binary_id = context.location_binary_id;
	}
	return context;
};
